import Vue from "vue";
import "vue2-datepicker/index.css";
import App from "./App.vue";
import i18n from "./i18n";
import VueI18n from "vue-i18n";
// import VueMeta from "vue-meta";
// import axios from "axios";
// import config from "@/config";
import xamatron from "./lib/xamatron";
import Vue2TouchEvents from "vue2-touch-events";
import moment from "moment";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/locale/fi";

Vue.config.productionTip = false;
Vue.use(VueI18n);
Vue.use(Vue2TouchEvents);
// Vue.use(VueMeta);

Vue.filter("formatDate", (value: Date) => {
    if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
});

Vue.component("date-picker", DatePicker as any);

xamatron.ready(() => {
    new App({
        i18n: new VueI18n({
            locale: "fi",
            fallbackLocale: "fi",
            ...i18n,
        })
    }).$mount("#app");
});
